export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";